import { BUSINESS, SITE_URL } from "../../../data/site"
import { LOCAL_BUSINESS_ID } from "./localBusiness"

type ArticleArgs = {
  headline: string
  description: string
  url: string
}

export const buildArticle = ({ headline, description, url }: ArticleArgs) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline,
  description,
  url: `${SITE_URL}${url}`,
  author: {
    "@type": "Person",
    name: BUSINESS.legalName,
    url: SITE_URL,
  },
  publisher: { "@id": LOCAL_BUSINESS_ID },
  inLanguage: "pt-BR",
})
